import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

export interface TopicCardProps {
  title: string;
  description: string;
  selected: boolean;
  onToggle: () => void;
  variant?: "desktop" | "mobile";
}

const CARD_WIDTH = 400;
const CARD_HEIGHT = 274;

export default function TopicCard({
  title,
  description,
  selected,
  onToggle,
  variant = "desktop",
}: TopicCardProps) {
  const isMobile = variant === "mobile";
  return (
    <Pressable
      onPress={onToggle}
      style={({ pressed }) => [
        styles.card,
        isMobile && styles.cardMobile,
        selected && styles.cardSelected,
        pressed && styles.cardPressed,
      ]}
    >
      <View style={styles.content}>
        <Text style={[styles.title, selected && styles.titleSelected]}>
          {title}
        </Text>
        <Text
          style={[styles.description, selected && styles.descriptionSelected]}
        >
          {description}
        </Text>
      </View>
      {selected && (
        <View style={styles.iconContainer}>
          <Ionicons name="heart" size={22} color="#ff6b9d" />
        </View>
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    width: CARD_WIDTH,
    minWidth: 350,
    height: CARD_HEIGHT,
    backgroundColor: "#f6f7f9",
    borderRadius: 16,
    padding: 32,
    borderWidth: 1,
    borderColor: "#d8dbe1",
    justifyContent: "center",
    alignItems: "center",
  },
  cardMobile: {
    width: "100%",
    maxWidth: 343,
    minWidth: 0,
    alignSelf: "center",
  },
  cardSelected: {
    borderColor: "#ff6b9d",
    borderWidth: 2,
    backgroundColor: "#ffffff",
  },
  cardPressed: {
    opacity: 0.8,
  },
  content: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: "900",
    color: "#2b2b2f",
    marginBottom: 12,
    textAlign: "center",
  },
  titleSelected: {
    color: "#2d2a26",
  },
  description: {
    fontSize: 16,
    color: "#2b2b2f",
    lineHeight: 20,
    textAlign: "center",
    opacity: 0.5,
  },
  descriptionSelected: {
    color: "#6a6a6a",
  },
  iconContainer: {
    position: "absolute",
    top: 14,
    right: 14,
  },
});
